// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__6iPoy","avatar":"Item_avatar__iPVj8","man":"Item_man__koGyP","position":"Item_position__EKw_l"};